import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

import About from './about';

import HomeAd from '../ads/homeAd';

import MeishiMap from './meishiMap';

import ThanksForChip from './thankFor';

class Home extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        handleTabChange: PropTypes.func,
    };

    render() {
        /**
         * 组件分发数据
         */
        const { information, homeAd, meishiMap, thanksFor } = this.props.content;

        return (
            <div className={styles.home}>
                <About content={information} />
                <HomeAd content={homeAd} />
                <MeishiMap content={meishiMap} handleChange={this.props.handleTabChange} />
                <ThanksForChip content={thanksFor} />
            </div>
        );
    }
}

export default errorBoundary(Home);
